import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import TeamAvatar from 'app/components/TeamAvatar';

import { getOpponentsFromComposedData } from './utils';
import style from './style.module.scss';

interface Props {
  data: ComposedEntityData;
}

const OpponentsHeader: FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const [opponent1, opponent2] = getOpponentsFromComposedData(data);

  return (
    <div className={style.opponentsHeader}>
      {opponent1 ? (
        <TeamAvatar
          team={opponent1}
          className={classNames(style.teamAvatar, style.teamAvatar_team1)}
        />
      ) : (
        <span className={style.teamAvatar} />
      )}
      <div className={style.matchTitle}>
        <span>{opponent1?.name ?? '-'}</span>
        <span>{t('all-versus')}</span>
        <span>{opponent2?.name ?? '-'}</span>
      </div>
      {opponent2 ? (
        <TeamAvatar
          team={opponent2}
          className={classNames(style.teamAvatar, style.teamAvatar_team2)}
        />
      ) : (
        <span className={style.teamAvatar} />
      )}
    </div>
  );
};

OpponentsHeader.displayName = 'OpponentsHeader';

export default OpponentsHeader;
